module.exports = __webpack_public_path__ + "img/logo_square_lapasar.84bd53ab.png";